module.exports = __webpack_public_path__ + "img/PERKI MOBILE.b79ff28d.svg";